$(document).ready(function () {
  $('.banner_slider .banner_list').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
  
  $(".reviews-slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1610,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
    ],
  });
  
  
});


// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.products-slider-section .product-slider').slick('refresh');
  
});


// PDP review rating click and redirect to tab
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const reviewWidget = document.querySelector('.yotpo-reviews-star-ratings-widget');
    if (reviewWidget) {
      reviewWidget.addEventListener('click', function() {
        // Find the tab link with href="#tab-review"
        const reviewTabLink = document.querySelector('ul.tabs a[href="#tab-review"]');
        const reviewTabContent = document.querySelector('#tab-review');

        if (reviewTabLink) {
          // Trigger the tab click to open Reviews tab
          reviewTabLink.click();
          if (reviewTabContent) {
            setTimeout(() => {
              reviewTabContent.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }, 300);
          }
        }
      });
    }
  }, 1000);
});

// cart page  
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.bold_cart_edit_button').forEach(button => {
    button.addEventListener('click', () => {
      initCreteYesNoOption();
      updateAlert();
    });
  });

  function initCreteYesNoOption() {
    setTimeout(() => {
      document.querySelectorAll('.bold_option_value input[type="checkbox"]').forEach(boldOption => {
        boldOption.addEventListener('click', () => {
          updateAlert();
        });
      });
    }, 1000); 
  }

  function updateAlert() {
    setTimeout(() => {
      // Run the logic only after clicking any edit button
      document.querySelectorAll('.bold_option_set input').forEach(input => {
        // Disable browser validation tooltips
        input.addEventListener('invalid', e => e.preventDefault());
        // console.log("update aler")
      });
    }, 1000); 
  }
});

